import SiteHeader from '../components/SiteHeader';
import Footer from '../components/Footer';
import useAuthModal from '../hooks/useAuthModal';

export default function ContactsScreen() {
  const authModal = useAuthModal();

  return (
    <div className="min-h-screen bg-white">
      <SiteHeader authModal={authModal} />

      <section className="max-w-4xl mx-auto px-6 pt-14 pb-8 text-center">
        <h1 className="text-4xl font-bold text-gray-900">
          Contact <span className="text-orange-500">Us</span>
        </h1>
        <p className="text-gray-500 mt-3">We're here to help — reach out anytime</p>
      </section>

      <main className="max-w-4xl mx-auto px-6 pb-20">
        {/* Contact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <div className="bg-gray-50 border border-gray-200 rounded-2xl p-6 text-center hover:border-orange-500 transition">
            <div className="w-12 h-12 bg-orange-50 rounded-xl flex items-center justify-center mx-auto mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
                className="w-6 h-6 text-orange-500"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
            </div>
            <h3 className="font-bold text-gray-900 mb-2">Email</h3>
            <a
              href="mailto:support@jobskills.work"
              className="text-orange-500 font-semibold hover:underline"
            >
              support@jobskills.work
            </a>
          </div>

          <div className="bg-gray-50 border border-gray-200 rounded-2xl p-6 text-center hover:border-orange-500 transition">
            <div className="w-12 h-12 bg-orange-50 rounded-xl flex items-center justify-center mx-auto mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
                className="w-6 h-6 text-orange-500"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            </div>
            <h3 className="font-bold text-gray-900 mb-2">Address</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Obchodná 559/37,
              <br />
              Bratislava, Slovakia
            </p>
          </div>
        </div>

        {/* Legal Information */}
        <section>
          <h2 className="text-2xl font-bold text-gray-900 text-center mb-6">
            Legal Information
          </h2>
          <div className="bg-gray-50 border border-gray-200 rounded-2xl overflow-hidden">
            <div className="flex flex-col md:flex-row border-b border-gray-200 p-4">
              <span className="font-semibold text-gray-900 md:w-48 mb-1 md:mb-0">Company Name</span>
              <span className="text-gray-600">Yevhenii Lisechko — a sole trader (živnosť) registered in Slovakia, IČO 57 687 099</span>
            </div>
            <div className="flex flex-col md:flex-row border-b border-gray-200 p-4">
              <span className="font-semibold text-gray-900 md:w-48 mb-1 md:mb-0">
                Registered Address
              </span>
              <span className="text-gray-600">
                Obchodná 559/37, 811 06 Bratislava-Staré Mesto, Slovakia
              </span>
            </div>
            <div className="flex flex-col md:flex-row border-b border-gray-200 p-4">
              <span className="font-semibold text-gray-900 md:w-48 mb-1 md:mb-0">
                Physical Address
              </span>
              <span className="text-gray-600">
                Obchodná 559/37, 811 06 Bratislava-Staré Mesto, Slovakia
              </span>
            </div>
            <div className="flex flex-col md:flex-row border-b border-gray-200 p-4">
              <span className="font-semibold text-gray-900 md:w-48 mb-1 md:mb-0">IČO (Slovak trade reg.)</span>
              <span className="text-gray-600">57 687 099</span>
            </div>
            <div className="flex flex-col md:flex-row p-4">
              <span className="font-semibold text-gray-900 md:w-48 mb-1 md:mb-0">Email</span>
              <span className="text-gray-600">support@jobskills.work</span>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
